import React from 'react'
import { midas } from '@resurs/midas'
import PropTypes from 'prop-types'

export const Step = ({ text, active, step }) => {
  let itemClass
  if (active) {
    itemClass = `${midas.stepItem} ${midas.active}`
  } else {
    itemClass = midas.stepItem
  }

  return (
    <li className={itemClass}>
      <a className={midas.tooltip} data-tooltip={`Steg ${step}`}>
        {text}
      </a>
    </li>
  )
}

Step.propTypes = {
  step: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  active: PropTypes.bool,
}

Step.defaultProps = {
  active: false,
}
